import React from "react";
import "../../css/pp-hero.css";
import PPHeroImglg from "../../assets/images/parentPage-hero-img-lg.png";
import PPHeroImgsm from "../../assets/images/parentPage-hero-img-sm.png";

const Hero = () => {
  return (
    <section id="pp-hero">
      <div>
        <article>
          <h1>Expert courses for your children to pass their exams easily</h1>
          <p>
            We're different. Flex is the only saas business platform that lets
            you run your business on one platform, seamlessly across all digital
            channels.
          </p>
          <div>
            <a href="" /* eslint-disable-line jsx-a11y/anchor-is-valid  */>
              Get started
            </a>
            <a href="" /* eslint-disable-line jsx-a11y/anchor-is-valid */>
              Learn more
            </a>
          </div>
        </article>
        <figure id="pp-hero-img">
          <img id="pp-h-img-lg" src={PPHeroImglg} alt="" />
          <img id="pp-h-img-sm" src={PPHeroImgsm} alt="" />
        </figure>
      </div>
    </section>
  );
};

export default Hero;
